import { Container } from '@mui/material';
import React from 'react';
import { theme } from 'ui-sdk/src/theme';

export const Chat: React.FC = ({ children }) => (
  <Container
    maxWidth={false}
    sx={{
      flexDirection: 'row',
      display: 'flex',
      height: '60vh',
      backgroundColor: 'transparent',
      padding: { xs: 0, md: theme.spacing(2) },
      paddingBottom: theme.spacing(10),
    }}
  >
    {children}
  </Container>
);
